import { NpStarsWithCount } from "src/components/np-design/components/NpStarsWithCount"
import { ProductLink } from "src/components/unstyled/ProductLink"
import { ListProductData } from "src/data/product-list/types"

export type NpProductCardTopProps = {
  product: ListProductData
  listId: string
  name: string
  description: string | undefined
}

export const NpProductCardTop = ({ product, listId, name, description }: NpProductCardTopProps) => {
  return product.rating ? (
    <>
      <div className="flex w-full items-start justify-between gap-4 text-left text-pretty">
        <ProductLink product={product} listId={listId}>
          <h3 className="font-product m-0 text-lg">{name}</h3>
        </ProductLink>
        <div>
          <NpStarsWithCount {...product.rating} />
        </div>
      </div>

      {description && <div className="text-left text-lg text-pretty">{description}</div>}
    </>
  ) : (
    <>
      <ProductLink product={product} listId={listId}>
        <h3 className="font-product m-0 text-lg">{name}</h3>
      </ProductLink>

      {description && <div className="text-lg text-pretty">{description}</div>}
    </>
  )
}
